import { render, staticRenderFns } from "./BasketDialog.vue?vue&type=template&id=3a540158&scoped=true"
import script from "./BasketDialog.vue?vue&type=script&lang=js"
export * from "./BasketDialog.vue?vue&type=script&lang=js"
import style0 from "./BasketDialog.vue?vue&type=style&index=0&id=3a540158&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a540158",
  null
  
)

export default component.exports